import React from 'react'
import Virtual_Start from '../../component/virtualstart/index';

export function VirtualStart() {
  return (
    <Virtual_Start />
  )
}
